import styles from "./contract-length.component.module.scss";
import SwitchButton2 from "../../../../Theme/switch-button-2/switch-button-2.component";
import NumberInputWithControls from "../../../../Common/number-input-with-controls/number-input-with-controls.component";

interface ContractLengthHandlers {
  handleIncrement: () => void;
  handleDecrement: () => void;
  handleChange: (value: string | number) => void;
  handleAutoRenewChange: (value: boolean) => void;
}

interface ContractLengthComponentProps {
  contractLength: number;
  autoRenew: boolean;
  handleContractLength: ContractLengthHandlers;
}

const ContractLengthComponent = ({ 
  contractLength,
  autoRenew,
  handleContractLength
}: ContractLengthComponentProps) => {

  
  return (
    <div>
      <div className={styles.container}>
        <NumberInputWithControls
          id="contract-length-input"
          value={contractLength}
          onChange={handleContractLength.handleChange}
          onIncrement={handleContractLength.handleIncrement}
          onDecrement={handleContractLength.handleDecrement}
          min="1"
          ariaLabel="Contract length in months"
          outputText="months"
        />
      </div>

      <div className={styles.autoRenewContainer}>
        <div className={styles.autoRenewWrapper}>
          <label
            htmlFor="auto-renew-toggle"
            className={styles.autoRenewLabel}
          >
            Auto-renew
          </label>

          <SwitchButton2
            active={autoRenew}
            onChange={handleContractLength.handleAutoRenewChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ContractLengthComponent;
